import * as React from 'react';

import { Actions } from '../AutomationCMSModals/types';

export default React.createContext<React.Dispatch<Actions>>(null);
